import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  notes: [],
};

export const notesSlice = createSlice({
  name: "notes",
  initialState,
  reducers: {
    updateNotes: (state, action) => {
      state.notes = action.payload;
    },
  },
});

export const { updateNotes } = notesSlice.actions;
export default notesSlice.reducer;
